/**
 * Stories implemented by Zillow Navbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { LogoLink } from '../../page-frame-types/LogoLink';
import { HEADER_VERSIONS } from '../../constants';
import { StaticDomainConfiguration } from '../../page-frame-types/StaticDomainConfiguration';
import { ZillowNavbarLogoContainer } from './components/ZillowNavbarLogoContainer';
import { ZillowNavbarLogoAnchor } from './components/ZillowNavbarLogoAnchor';
import { ZillowNavbarLogoImage } from './components/ZillowNavbarLogoImage/ZillowNavbarLogoImage';

type ZillowNavbarLogoProps = {
    /**
     * The logo link configuration
     */
    logo: LogoLink;
    /**
     * Used for configuring the styling of the image
     */
    isMobileNavOpen: boolean;
    /**
     * Used for configuring the styling of the image
     */
    version: HEADER_VERSIONS;
    /**
     * Used for configuring the CDN of the image
     */
    staticDomain: StaticDomainConfiguration;
};

export const ZillowNavbarLogo: FunctionComponent<ZillowNavbarLogoProps> = ({
    logo,
    isMobileNavOpen,
    version,
    staticDomain,
}) => (
    <ZillowNavbarLogoContainer version={version} isMobileNavOpen={isMobileNavOpen}>
        <ZillowNavbarLogoAnchor href={logo.href} aria-label={logo.text}>
            <ZillowNavbarLogoImage isMobileNavOpen={isMobileNavOpen} version={version} staticDomain={staticDomain} />
        </ZillowNavbarLogoAnchor>
    </ZillowNavbarLogoContainer>
);
